export enum AmendEmailDialogFormLabelsEnum {
  TITLE = 'Amend Email',
  SEND = 'Send',
  SKIP = 'Skip',
  CANCEL = 'Cancel',
}
